import React, {Component} from 'react';
import Help from '../../generics/help';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';
import list from '../../process/modify/list';

var Config = require('../../../config');

class ListStoreUnits extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onFilter = this.onFilter.bind(this);

        this.state = {
            filter:"",
            list:[]
        }
    }

    componentDidMount(){
        fetch(Config.default.apiGateway.URL+'units/storage_list?hf_id='+sessionStorage.getItem('health_facilities_id'),{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    return swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({list: response});
            }
        });
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    onFilter(row){
        var res = true;
    
        var string = row.equipment_name+' '+row.ubication+' '+row.unit_number+' '+row.code+' '+row.component_number;

        if(string.toLowerCase().indexOf(this.state.filter.toLowerCase()) !== -1){
            res = true;
        }else{
            res = false;
        }

        return res;
    }

    render(){
        const {t} = this.props;

        return (
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.warehouse.MAIN')} ->
						{t('sidebar.nav.warehouse.storeUnits')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_units_set_storage"}  />
                <div className="col-xs-12 form-group">
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <input name="filter" id="filter" value={this.state.filter} onChange={(e)=>this.handleChange(e)} 
                                className="form-control" placeholder="Buscar..."
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2 col-md-1">
                            <button className="btn btn-info" onClick={(e)=>{e.preventDefault(); return this.props.history.push('/warehouse/storeUnits/new');}}>
                                Nuevo
                            </button>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>Equipo</th>
                                    <th>Ubicación</th>
                                    <th>No. Unidad</th>
                                    <th>Código de componente</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, i)=>
                                    this.onFilter(list) &&
                                        <tr key={i}>
                                            <td>{list.equipment_name}</td>
                                            <td>{list.ubication}</td>
                                            <td>{list.unit_number}</td>
                                            <td>{list.code+' '+list.component_number}</td>
                                        </tr>
                                )}
                            </tbody>
                        </Table>
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations')(ListStoreUnits);